import WorkspacePreview from './WorkspacePreview';
import FullScreenPreview from './FullScreenPreview';

export default WorkspacePreview;

export { WorkspacePreview, FullScreenPreview };
